import { createActionNamespace } from 'Modules/core/redux';


const infoAction = createActionNamespace('info');

export const infoActions = {
    get: infoAction('GET'),
    set: infoAction('SET'),
};
